import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import i18n from 'i18n-js';
import useStyles from './priority.styled';
import { priorities } from 'constants/common';
import SvgIcon from '@material-ui/core/SvgIcon';
import { Box, Typography } from '@material-ui/core';

const Priority = ({ priority, fontSize, placeholder, gutterBottom }) => {
  const classes = useStyles();

  const priorityIcon = priorities.find((el) => el.value === priority);

  return (
    <Typography variant="h6" gutterBottom={gutterBottom}>
      <Box
        display="flex"
        fontSize={fontSize}
        alignItems="center"
        fontWeight="fontWeightMedium"
        className={clsx(classes[priority])}
      >
        {priority ? (
          <>
            <SvgIcon component={priorityIcon?.icon} className={classes?.icon} />
            {i18n.t(`priorities.${priority}`)}
          </>
        ) : (
          <Typography>{placeholder}</Typography>
        )}
      </Box>
    </Typography>
  );
};

Priority.propTypes = {
  fontSize: PropTypes.number,
  gutterBottom: PropTypes.bool,
  placeholder: PropTypes.string,
  priority: PropTypes.oneOf(['LOW', 'HIGH', 'MEDIUM', 'URGENT']).isRequired,
};

Priority.defaultProps = {
  fontSize: 13,
  placeholder: '--',
  gutterBottom: true,
};

export default Priority;
